import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatDate, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_INDIVIDUALS,
	STR_GROUPS,
	STR_CREATE_NEW_CONTACT,
	STR_INVALID_NAME,
	STR_INVALID_PHONE,
	STR_INVALID_WHATSAPP_NUMBER,
	STR_SUCCESS,
	STR_NAME,
	STR_PHONE_NUMBER,
	STR_WHATSAPP_NUMBER,
	STR_OPTIONAL,
	STR_SUBMIT,
	STR_NO_RECORD,
	STR_DATE_REQUESTED,
	STR_REGISTRATION_STATUS,
	STR_PAYMENT_STATUS,
	STR_PRICE
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdInfoOutline, MdMessage, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdPeople, MdWhatsapp } from 'react-icons/md';
import { GiPayMoney } from "react-icons/gi";
import { TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import OneContact from '../ones/OneContact';

export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState(null);
	

	async function init() {
		//run initializations here
		setReady(false);
		await getData();
		setReady(true);
	}

	

	async function getData() {
		await callApi(
			"get-sender-id-request-data",
			{
				id,
			}
		).then((response) => {
			if(response.status === 1) {
				setData(response.data)
			} 
		})
	}


	useEffect(() => {
		init();
	}, [])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
	}, [ loading ])

	if (ready) {
		return (
			<div
				className="container"
			>
			
				<div className="row">

					<div className="col-md-12">
						<h6
							className="font-semi-bold"
							style={{
								fontSize: "32px"
							}}
						>
							{data.senderId}
						</h6>

						

						<hr/>

						<h6
							style={{
								fontSize: "14px",
							}}
							className="font-regular"
						>
							{STR_PRICE[appContext.language]}: : <span className="font-semi-bold">{formatMoney(data.price)} TZS</span>
						</h6>
						<h6
							style={{
								fontSize: "12px",
							}}
							className="font-regular mt-4"
						>
							{STR_PAYMENT_STATUS[appContext.language]}: : <span className="font-semi-bold">{data.paymentStatus}</span>
						</h6>

						<h6
							style={{
								fontSize: "12px",
							}}
							className="font-regular mb-4"
						>
							{STR_REGISTRATION_STATUS[appContext.language]}: <span className="font-semi-bold">{data.registrationStatus}</span>
						</h6>
			
						<h6
							style={{
								fontSize: "12px",
							}}
							className="font-regular text-end"
						>
							{formatDate(data.dateRequested)}
							<span className="d-block font-light">{STR_DATE_REQUESTED[appContext.language]}</span>
						</h6>

					</div>

					
					
				</div>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}